/** Adaptive contact channels for a person. Empty/whitespace strings collapse to null. */
export interface ContactChannels {
  phone: string | null
  email: string | null
  hasAny: boolean
}

const clean = (v: string | null | undefined): string | null => {
  const t = (v ?? '').trim()
  return t.length > 0 ? t : null
}

/** Resolve whichever channels actually exist; `hasAny` gates the whole contact affordance. */
export function resolveContactChannels(input?: {
  phone?: string | null | undefined
  email?: string | null | undefined
}): ContactChannels {
  const phone = clean(input?.phone)
  const email = clean(input?.email)
  return { phone, email, hasAny: phone !== null || email !== null }
}
